import { useMemo } from "react";
import { createSlice } from "@reduxjs/toolkit";

import { useInjectReducer } from "utils/@reduxjs/useInjectReducer";
import { useInjectSaga } from "utils/@reduxjs/useInjectSaga";

import { creatorsSaga } from "./saga";
//
export const initialState = {
  creators: {
    initialLoading: true,
    loading: false,
    error: null,
    levels: [],
    states: [],
    cities: [],
    companies: [],
    total_creators: 0,
    creators: [],
    pagination: {}
  }
};

export const CreatorsSlice = createSlice({
  name: "creators",
  initialState,
  reducers: {
    // --- Creators ---
    fetchCreators: (state, action) => {
      state.creators.loading = true;
      state.creators.error = null;
    },
    fetchCreatorsSuccess: (state, action) => {
      const { creators, total_creators, pagination, levels, facets } =
        action.payload;
      state.creators.loading = false;
      state.creators.initialLoading = false;
      state.creators.creators = creators;
      state.creators.levels = levels;
      // Facets
      state.creators.states = facets?.states || [];
      state.creators.cities = facets?.cities || [];
      state.creators.companies = facets?.companies || [];
      state.creators.managed_by = facets?.managed_by || [];

      state.creators.total_creators = total_creators;
      state.creators.pagination = pagination;
    },
    fetchCreatorsFailure: (state, action) => {
      state.creators.loading = false;
      state.creators.initialLoading = false;
      state.creators.error = action.payload;
    }
  }
});

// custom hooks
export const useCreatorsSlice = () => {
  useInjectReducer(CreatorsSlice.name, CreatorsSlice.reducer);
  useInjectSaga(CreatorsSlice.name, creatorsSaga);

  const actions = useMemo(() => CreatorsSlice.actions, []);
  return { actions };
};

export const { actions: creatorsActions } = CreatorsSlice;
export default CreatorsSlice.reducer;
